import { render, staticRenderFns } from "./arReviewedValidation.vue?vue&type=template&id=22b6121a"
import script from "./arReviewedValidation.vue?vue&type=script&lang=js"
export * from "./arReviewedValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports